import { createApp, h } from "vue";
import Search from "@/app/search/Search.vue";
import { ApiService, DOMUtil, TranslationService } from "webshop-modules";
import {
    CategoryTranslations,
    CountryTranslations,
    SearchAppData
} from "@/domain/search/entitites/TranslationsData.interface";
import { StringUtilities } from "webshop-modules/string/String.utilities";
import { ApiPlugin } from "@/plugins/api.plugin";
import { TranslationPlugin } from "@/plugins/translation.plugin";
import { createPinia, getActivePinia } from "pinia";
import vueDebounce from 'vue-debounce';
import VCalendar from 'v-calendar';
import 'v-calendar/style.css';

// Initial data
const configScript = DOMUtil.getInjectedConfigurationScript(document, 'vue-applications-v3/search.js') as HTMLScriptElement;
const data: SearchAppData = {
    categoryTranslations: JSON.parse(
        StringUtilities.unescape(
            configScript.getAttribute('data-categoryTranslations') as string
        )
    ) as CategoryTranslations,
    countryTranslations: JSON.parse(
        StringUtilities.unescape(
            configScript.getAttribute('data-countryTranslations') as string
        )
    ) as CountryTranslations,
    showArtistResults: configScript.getAttribute('data-artist-show-results') === 'true'
};

const searchInstance = createApp({
    render: () => h(Search, { data }),
})

const pinia = getActivePinia() ?? createPinia();
searchInstance.use(pinia);

// Set module plugins
searchInstance.use(new ApiPlugin(ApiService.getInjectedConfiguration(document, 'vue-applications-v3/search.js')));
searchInstance.use(new TranslationPlugin(TranslationService.getConfiguration(document, 'vue-applications-v3/search.js')));
searchInstance.use(vueDebounce, { listenTo: 'input' });
searchInstance.use(VCalendar, {
    locales: TranslationService.getLocale(),
    color: 'var(--datepicker-text-color)',
});

configScript.removeAttribute('data-categoryTranslations');
configScript.removeAttribute('data-countryTranslations');

searchInstance.mount('#search-app');

